import React from 'react';
import MaterialSkeleton from '@mui/material/Skeleton';

type Props = {
  className?: string;
  height?: string;
  width?: string;
};

export default function LoadingSkeleton({
  className,
  height = '100px',
  width = '100%',
}: Props) {
  return (
    <>
      <MaterialSkeleton
        className={`bp-rounded-lg ${className}`}
        height={height}
        variant="rectangular"
        width={width}
      />
    </>
  );
}
